import type { ActivationState } from "src/pages/UserDashboard/WorkPackets/activation-status/activation-status-types";

export const getColorByCustomerStatus = (status?: ActivationState): string => {
  const colorMap = {
    active: "#39D4A5",
    inactive: "#E03741",
    sunset: "#FFA500",
  };

  return status ? colorMap[status] : "transparent";
};
